import { apiPOST } from '../../lib/api'

export const postDelayNotificationHandled = (
  notificationKey: string,
  resolution: string
): Promise<void> => apiPOST('/delayNotificationHandling', { notificationKey, resolution })
